<template>
    <div>
        <h3>解决方案列表</h3>
        <el-form :inline="true" class="demo-form-inline" size="mini">
            <el-form-item label="解决方案id">
                <el-input v-model="filter.solutionId" placeholder="解决方案id"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="fetch(1)" size="mini">查询</el-button>
                <el-button type="primary" @click="$router.push('/solution')" size="mini">新建</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="list" size="mini" v-loading="loading">
            <el-table-column prop="solutionId" label="解决方案id"></el-table-column>
            <el-table-column prop="solutionName" label="解决方案名称"></el-table-column>
            <el-table-column prop="relevanceJob" label="关联职位"></el-table-column>
            <el-table-column prop="categories" label="所属类目">
                <template slot-scope="scope">{{formatCate(scope.row.categories)}}</template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <a :href="`/solution/${scope.row.solutionId}`">修改</a>
                </template>
            </el-table-column>
        </el-table>
        <br/>
        <div>
            <el-pagination background layout="prev, pager, next" :current-page="pageNum" @current-change="i=>pageNum=i" :page-size="limit" :total="total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import map from '../../datamap'
import api from '../api'

const {
    solution,
} = api

export default {
    name: 'solutions',
    data() {
        return {
            map,
            loading: true,
            list: [],
            total: 0,
            limit: 20,
            pageNum: 1,
            total: 0,
            filter: {
                solutionId: '',
            },
        }
    },
    components: {},
    computed: {
        nickUserName() {
            return location.search;
        },
        payChannel() {
            return map.payChannel;
        },
        publisherId() {
            return this.$route.query.publisherId;
        },
    },
    watch: {
        pageNum() {
            this.fetch(2)
        },
    },
    methods: {
        toggleDialog(name, data = {}) {
            this.dialog[name] = !this.dialog[name];
            this.curJob = data;
            this.closeReason = '';
        },
        async fetch(num) {

            if (num == 1) {
                this.pageNum = 1
            }

            let pageNum = this.pageNum
            let limit = this.limit
            this.loading = true

            let {
                solutionId,
            } = this.filter

            let obj = {
                pageNum: pageNum,
                limit: limit,
                solutionId,
            }

            let res = await solution.list(obj)

            this.list = res.data.data
            this.loading = false
            this.total = res.data.pageinfo.totalCount
        },
        formatCate(arr) {
            let str = ''
            if (arr.length) {
                arr.forEach((item, index) => {
                    if (index == arr.length - 1) {
                        str += item.name
                    } else {
                        str += `${item.name}、`
                    }
                })
            }
            return str;
        },
    },
    mounted() {
        this.fetch()
    },
}
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/views/solution/list.vue